// extracted by mini-css-extract-plugin
export default {"FeaturesTable":"FeaturesTable-module__FeaturesTable--hlbnI","FeaturesTable__srOnly":"FeaturesTable-module__FeaturesTable__srOnly--dlwNu"};